import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import Banner from "@/components/office/Banner";
import TouristTabBar from "@/components/office/TouristTabBar";
import OfficeApp from "@/components/office/OfficeApp";
import OfficeServe from "@/components/office/OfficeServe";
import OfficeTool from "@/components/office/OfficeTool";
import Sidebar from "@/components/messageBox/Sidebar";
export default {
  name: "Office",
  props: [],
  components: {
    Banner: Banner,
    TouristTabBar: TouristTabBar,
    OfficeApp: OfficeApp,
    OfficeServe: OfficeServe,
    OfficeTool: OfficeTool,
    Sidebar: Sidebar
  },
  data: function data() {
    return {
      touristActive: this.userToken ? "" : "tourist"
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setTouristActive: function setTouristActive(value) {
      this.touristActive = value;
    }
  },
  watch: {
    userToken: function userToken(value) {
      if (value) {
        this.touristActive = "";
      }
    }
  },
  filters: {}
};